function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 42,
  rx: 5,
  fill: "#d72b27"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M-125.108-60.776c-1.107-1.091-4.509-.755-6.041-.55a8.586,8.586,0,0,1-3.7-4.643c.353-1.477.979-3.873.525-5.32a1.918,1.918,0,0,0-2.124-1.687,1.913,1.913,0,0,0-1.532,1.127c-.41,1.5-.025,3.64.688,6.383a79.281,79.281,0,0,1-3.453,7.267c-1.705.878-4.435,2.4-4.82,4.3-.287,1.378,1.878,3.233,4.353.525a22.056,22.056,0,0,0,2.566-3.733,47.43,47.43,0,0,1,6.716-1.969,12.516,12.516,0,0,0,5.3,1.633,1.989,1.989,0,0,0,2.044-1.932A1.983,1.983,0,0,0-125.108-60.776Zm-18.791,7.3a11.429,11.429,0,0,1,2.91-3.348C-142.8-53.927-143.9-53.417-143.9-53.474Zm7.8-18.236c.714,0,.639,3.08.172,3.9a7.966,7.966,0,0,1-.172-3.906Zm-2.328,13.067a38.684,38.684,0,0,0,2.362-5.225,10.691,10.691,0,0,0,2.878,3.405A29.759,29.759,0,0,0-138.423-58.644Zm12.575-.484s-.476.574-3.566-.746c3.362-.245,3.91.525,3.566.748Z",
  transform: "translate(150.588 88.989)",
  fill: "#fff"
});

var SvgPdfIcon = function SvgPdfIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf_icon.01252f37.svg";
export { ForwardRef as ReactComponent };